import { logQueueActionEvent } from "./logQueueActionEvent";
import type { QueueActionType } from "../properties/event/queueActionProperties";
import { store } from "global";

export function logQueueHistoryOnOffEvent() {
    const { historyOpen } = store.getState().queue;
    const type: QueueActionType = historyOpen ? "TurnHistoryOn" : "TurnHistoryOff";
    logQueueActionEvent(type);
}
